define([
	"dojo/_base/declare",
	"csi/view",
	"SiteAdmin/LocaleResourceController"
], function(declare,csiView,LocaleResourceController) {

	return declare(LocaleResourceController, {
		postProcessSuccess: function() {
			// summary: refresh plural value and attributes table
			this.inherited(arguments);

			var	h = this.widget.defView.m_headings[3];
			var	key = this._ctx.keyValue;

// FIX: refresh plural value
			this._ctx.keyValue = h.m_index;
			this.widget.refreshHeadingCell(this._ctx, h, this.refNode.nextSibling);
			this._ctx.keyValue = key;

			csiView.getView("LocaleAttributes").refreshWidget();
		}
	});
});